const clean = path => (path.split(/[?#]/)[0].replace(/\/+$/, "") || "/").toLowerCase();

/** A child destination wins over its parent list; detail URLs retain their list. */
export function activeNavigationItem(groups, pathname, pathFor = path => path) {
  const current = clean(pathname);
  let selected = null, length = -1;
  for (const group of groups) for (const item of group.items) {
    for (const route of [item.to, ...(item.activePaths || [])]) {
      const candidate = clean(pathFor(route));
      if ((current === candidate || (!item.end && current.startsWith(candidate + "/"))) && candidate.length > length) {
        selected = item.to; length = candidate.length;
      }
    }
  }
  return selected;
}
